module.exports = __webpack_public_path__ + "img/arrow.b6406b4f.svg";